export const KEY_COUPONS = 'partner/coupons'
export const KEY_PARTNER = '/partners'
export const KEY_BUSINESS_UNITS = 'businessUnits'
